import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { TravelService } from 'src/app/service/travel.service';
import * as _moment from 'moment';
import { getFromLocalStorage, setToLocalStorage } from 'src/app/shared/helpers';

@Component({
  selector: 'app-period-edit',
  templateUrl: './period-edit.component.html',
  styleUrls: ['./period-edit.component.scss']
})
export class PeriodEditComponent implements OnInit {
  formAlias: string;
  editModeMap = {};
  form: FormGroup;
  minstartDate: Date;
  maxstartDate: Date;
  minendDate: Date;
  maxendDate: Date;
  duration: number;
  submitted = false;
  constructor(protected fb: FormBuilder, private service: TravelService) { }

  ngOnInit(): void {
    this.minstartDate = new Date();
    this.maxstartDate = new Date();
    this.minendDate = new Date();
    this.maxendDate = new Date();

    this.formAlias = 'InsurancePeriod';
    this.form = this.fb.group({
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]]
    });

    this.form.get('startDate').valueChanges.pipe(take(1)).subscribe(value => {
      if (typeof value === 'string') {
        this.form.get('startDate').setValue(new Date(this.formData.startDate));
      }
    });
    this.form.get('endDate').valueChanges.pipe(take(1)).subscribe(value => {
      if (typeof value === 'string') {
        this.form.get('endDate').setValue(new Date(this.formData.endDate));
      }
    });

    this.form.patchValue(this.formData);

    this.maxstartDate.setDate(this.maxstartDate.getDate() + 180);
    this.minendDate.setDate(this.minendDate.getDate() + 1);
    this.maxendDate.setDate(this.maxendDate.getDate() + 365);

  }

  onEdit(index: number) {
    this.editModeMap[index] = true;
  }

  done(index: number) {
    // calculate days
    const duration = _moment
      .duration(
        _moment(this.form.get('endDate').value).diff(
          _moment(this.form.get('startDate').value)
        )
      )
      .asDays() + 1;

      this.duration =  Math.ceil(duration);

    if (this.form.valid) {
      this.editModeMap[index] = false;
      setToLocalStorage('policy', this.formAlias, this.form.value);
      setToLocalStorage('calculate', 'travelPeriodInDays', this.duration);
      this.service.calculateAgain();
    } else {
      this.submitted = true;
    }
  }

  changeStartDate(value) {
    var nextDay = new Date(value);
    nextDay.setDate(nextDay.getDate() + 1);
    this.minendDate = nextDay;
  }

  get policy(): any {
    return JSON.parse(localStorage.getItem('policy'));
  }

  get formData() {
    const formValue = getFromLocalStorage('policy');
    return formValue && formValue[this.formAlias] ? formValue[this.formAlias] : {} && new Date(parseInt(localStorage.getItem('policy')));
  }

}
